/** Shared app color palette (MapViewer / TopBar / UserManagement) */
export const APP_COLORS = {
  primary: "#003376",
  primaryDark: "#002855",
  primaryMid: "#1976d2",
  primaryLight: "#E3F2FD",
  accent: "#4caf50",
  accentDark: "#45a049",
  background: "#f5f5f5",
  surface: "#ffffff",
  border: "#e0e0e0",
  borderBlue: "#dbeafe",
  text: "#1e293b",
  textMuted: "#64748b",
  textOnPrimary: "#ffffff",
};
